// store/stylesAccessStore.js
// Grant de acceso al editor de estilos. POR SESION y EN MEMORIA: no se persiste,
// asi que al recargar o cerrar la pestana se pierde y hay que volver a verificar
// el codigo (mas seguro para cuentas de profesor compartidas). Durante la
// navegacion SPA (sin recarga) se mantiene. Lo emite el backend tras el OTP
// (ver Page_StylesAccess) y lo consumen el gating (AppSidebar, AdminRouter,
// Page_Styles) y la api (cabecera x-styles-grant).
import { create } from "zustand";

export const useStylesAccessStore = create((set) => ({
  grant: null,
  email: null,
  isApprover: false,
  setGrant: ({ grant, email, isApprover }) =>
    set({ grant, email, isApprover: !!isApprover }),
  clear: () => set({ grant: null, email: null, isApprover: false }),
}));

// Helpers fuera de React (para la api).
export function getStylesGrant() {
  return useStylesAccessStore.getState().grant || "";
}
export function hasStylesAccess() {
  return !!useStylesAccessStore.getState().grant;
}
